export enum AccountPath {
  ACCOUNT_SETTING = ':name',
}
